import { useMemo } from "react";

import Link from "components/Link";
import { Paths } from "configs";
import { usePermission } from "hooks";

interface Props {
  label: string | React.ReactNode;
  pathName: keyof typeof Paths;
  id?: number | string;
  openNewTab?: boolean;
}

const PathLink: React.FC<Props> = ({
  label,
  pathName,
  id,
  openNewTab = false,
}) => {
  const { canAccess } = usePermission();
  const to = useMemo(() => {
    if (pathName === "EmployeeDetail" && !canAccess("EmployeeDetail")) {
      return "";
    }
    if (
      pathName === "SalaryAdvanceDetail" &&
      !canAccess("SalaryAdvanceDetail")
    ) {
      return "";
    }
    if (
      pathName === "SalaryPaymentDetail" &&
      !canAccess("SalaryPaymentDetail")
    ) {
      return "";
    }
    return `${(Paths[pathName] as string) || ""}${id ? `/${id}` : ""}`;
  }, [canAccess, id, pathName]);

  return (
    <Link to={to} target={openNewTab ? "_blank" : "_self"}>
      {label}
    </Link>
  );
};

export default PathLink;
